module.exports = __webpack_public_path__ + "static/media/Door2_Before.0b044f47.jpg";